document.querySelectorAll('[data-nav-toggle]').forEach((button) => {
  const nav = document.getElementById(button.getAttribute('aria-controls'));
  const syncNavigation = () => {
    const mobile = window.matchMedia('(max-width: 900px)').matches;
    if (!mobile) {
      nav.hidden = false;
      button.setAttribute('aria-expanded', 'false');
    } else if (button.getAttribute('aria-expanded') !== 'true') {
      nav.hidden = true;
    }
  };
  syncNavigation();
  window.addEventListener('resize', syncNavigation);
  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    nav.hidden = open;
  });
});

document.querySelectorAll('.product-form').forEach((form) => {
  const select = form.querySelector('[data-variant-select]');
  if (!select) return;
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    form.querySelector('[name="id"]').value = option.value;
    const price = document.querySelector('[data-product-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    const button = form.querySelector('[type="submit"]');
    button.disabled = option.disabled;
    button.textContent = option.disabled ? 'Sold out' : 'Add to cart';
  });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('[data-gallery-main]');
  const mainButton = gallery.querySelector('[data-gallery-lightbox]');
  if (!mainImage || !mainButton) return;
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      mainImage.srcset = '';
      mainImage.src = thumb.dataset.image;
      mainImage.alt = thumb.dataset.alt || '';
      mainButton.dataset.lightboxImage = thumb.dataset.full;
      mainButton.dataset.lightboxAlt = thumb.dataset.alt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
});

const lightbox = document.querySelector('[data-image-lightbox]');
if (lightbox) {
  const target = lightbox.querySelector('[data-lightbox-target]');
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lightbox-image]');
    if (!button) return;
    target.src = button.dataset.lightboxImage;
    target.alt = button.dataset.lightboxAlt || '';
    lightbox.showModal();
  });
  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });
  lightbox.addEventListener('close', () => {
    target.src = '';
    target.alt = '';
  });
}
